const MINUTE_SECONDS = 60
const HOUR_SECONDS = 60 * MINUTE_SECONDS
export const DATA_TIMEOUT_SECONDS = 1 * HOUR_SECONDS
